var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m12 23c-.147 0-.287-.065-.383-.178l-11.5-13.659c-.133-.158-.155-.382-.056-.562l4.032-7.341c.088-.16.256-.26.438-.26h14.938c.183 0 .351.1.438.26l4.031 7.341c.1.181.077.404-.056.562l-11.5 13.659c-.095.113-.235.178-.382.178zm-10.896-14.219 10.896 12.943 10.896-12.943-3.723-6.781h-14.346z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m23.25 9.5h-22.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h22.5c.276 0 .5.224.5.5s-.224.5-.5.5z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m17.062 9.219c-.157 0-.312-.074-.409-.213l-4.651-6.633-4.592 6.598c-.156.227-.469.282-.695.125-.228-.158-.283-.469-.125-.696l5-7.186c.093-.134.246-.214.409-.214h.001c.163 0 .315.079.409.213l5.062 7.219c.159.227.104.538-.122.696-.086.061-.187.091-.287.091z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m12 23c-.212 0-.4-.133-.471-.332l-7.469-21c-.092-.261.044-.547.303-.639.262-.096.547.043.639.303l6.998 19.676 6.998-19.676c.092-.259.377-.397.639-.303.26.092.396.378.303.639l-7.469 21c-.071.199-.259.332-.471.332z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.e4b1299c354dcf6ebc55a67d71df9ce4.svg";
export { ForwardRef as ReactComponent };